import { render } from "./AddFriendDialog.vue?vue&type=template&id=56404dba&scoped=true"
import script from "./AddFriendDialog.vue?vue&type=script&lang=js"
export * from "./AddFriendDialog.vue?vue&type=script&lang=js"

import "./AddFriendDialog.vue?vue&type=style&index=0&id=56404dba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56404dba"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QForm,QInput,QBtn});
